module.exports = __webpack_public_path__ + "img/erro.0f0cf65f.svg";